export default "__VITE_ASSET__CJoof6Ae__"